const partnership = () => {
    const existingOwners = [];
    const invitedAccountlessOwners = [];
    let existingInvitedAccountlessOwner = {};

    [].slice.call(document.querySelectorAll('[data-owner]')).forEach((owner) => {
        existingOwners.push({
            name: owner.dataset.owner,
            id: owner.value,
            ownerIndex: owner.dataset.owner_index,
            alreadyOnTheUi: true
        });
    });

    [].slice.call(document.querySelectorAll('[data-invited_accountless_owner]')).forEach((invitedAccountlessOwner) => {
        existingInvitedAccountlessOwner = {
            id: invitedAccountlessOwner.value,
            title: invitedAccountlessOwner.dataset.invited_accountless_owner_title,
            firstName: invitedAccountlessOwner.dataset.invited_accountless_owner_first_name,
            lastName: invitedAccountlessOwner.dataset.invited_accountless_owner_last_name,
            invitedAccountlessOwnerIndex: invitedAccountlessOwner.dataset.invited_accountless_owner_index,
            alreadyInvited: true
        };

        existingInvitedAccountlessOwner.name = `${existingInvitedAccountlessOwner.title} ${existingInvitedAccountlessOwner.firstName} ${existingInvitedAccountlessOwner.lastName}`;

        invitedAccountlessOwners.push(existingInvitedAccountlessOwner);
    });

    return {
        showOwnerInput: false,
        showAccountlessOwnerInput: false,
        dogOwners: existingOwners,
        dogInvitedAccountlessOwners: invitedAccountlessOwners,
        ownerEmail: '',
        value: '',
        invitedAccountlessIndex: invitedAccountlessOwners.length,
        newAccountlessOwner: {
            title: '',
            firstName: '',
            lastName: ''
        },

        deleteOwner(ownerIndex) {
            [].slice
                .call(document.querySelectorAll(`input[data-owner][data-owner_index="${ownerIndex}"]`))
                .forEach((input) => {
                    input.remove();
                });

            this.dogOwners = this.dogOwners.filter((owner) => ownerIndex !== owner.ownerIndex);
        },

        addInvitedAccountlessOwner() {
            const ownersUi = document.querySelector('[data-dog-owners]');

            if (
                this.newAccountlessOwner.firstName.trim() === '' ||
                this.newAccountlessOwner.lastName.trim() === ''
            ) {
                return;
            }
            ownersUi.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            this.dogInvitedAccountlessOwners.push({
                id: null,
                title: this.newAccountlessOwner.title,
                firstName: this.newAccountlessOwner.firstName,
                lastName: this.newAccountlessOwner.lastName,
                name: `${this.newAccountlessOwner.title} ${this.newAccountlessOwner.firstName} ${this.newAccountlessOwner.lastName}`,
                invitedAccountlessOwnerIndex: this.invitedAccountlessIndex,
                alreadyInvited: false
            });

            this.invitedAccountlessIndex += 1;
            this.newAccountlessOwner.title = '';
            this.newAccountlessOwner.firstName = '';
            this.newAccountlessOwner.lastName = '';
        },

        deleteInvitedAccountlessOwner(invitedAccountlessOwnerIndex) {
            [].slice
                .call(
                    document.querySelectorAll(
                        `input[data-invited_accountless_owner][data-invited_accountless_owner_index="${invitedAccountlessOwnerIndex}"]`
                    )
                )
                .forEach((input) => {
                    input.remove();
                });

            this.dogInvitedAccountlessOwners = this.dogInvitedAccountlessOwners.filter(
                (invitedAccountlessOwner) =>
                    invitedAccountlessOwnerIndex !== invitedAccountlessOwner.invitedAccountlessOwnerIndex
            );
        },

        submitForm() {
            const form = document.querySelector('[data-partnership-form]');

            if (form) form.submit();
        }
    };
};

export default function partners() {
    window.partners = partnership;
}



// WEBPACK FOOTER //
// ./resources/js/frontend/components/partnership.js